<template>
  <div class="justify-content-center">

    <div class="row pt-2 pt-md-0" v-if="isTherapist && !isMensurationForbidden">
      <div class="col-sm-4 col-lg-6">
        <h1 class="page-title">{{'user.clients' | trans}}</h1>
      </div>
      <div class="col-sm-8 col-lg-6 text-right" :class="{'hash-invalid': errors.has('code') || responseHashError}">
        <mdc-textfield id="code"
                       :label="'user.clientHash' | trans"
                       type="text"
                       name="code"
                       class="header-btn client-hash"
                       :class="{'is-invalid': errors.has('code') || responseHashError}"
                       v-validate="'required|alpha_dash|max:8'"
                       v-model="user.code"
                       data-vv-validate-on="none"
                       :data-vv-as="'user.clientHash' | trans"/>

        <span class="invalid-feedback"
              v-if="errors.has('code')">
                    <strong>{{ errors.first('code') }}</strong>
                </span>
        <span class="invalid-feedback"
              :class="{'d-block': responseHashError}"
              v-if="responseHashError && !errors.has('code')">
                    <strong>{{ responseHashError }}</strong>
                </span>
        <mdc-button class="button-primary" raised
                    @click.prevent="addHashBtnClick">
          {{ 'user.add' | trans }}
        </mdc-button>
      </div>
    </div>

    <table-view
        :options="options"
        :isLoaded=isLoaded
        :isChange="isChange"
        v-on:on-search="onSearchEnter">
          <div slot="client" slot-scope="props">
            <router-link
                :to="{ name: 'client-edit', params: { clientId: props.row.id }}" class="name-link">
              <div class="icon-circle icon-purple"><span v-if="!isMobile">{{'user.C' | trans}}</span></div>

              <strong>{{ props.row.code }}</strong>
            </router-link>
          </div>
          <div slot="action" slot-scope="props">
            <client-btn v-if="canUpdateClient || canDeleteClient"
                        :item="props.row"
                        :showEdit="canUpdateClient"
                        :showDelete="canDeleteClient"
                        v-on:editItem="onEditBtnClick"
                        v-on:deleteItem="onDeleteBtnClick">
            </client-btn>
          </div>
    </table-view>

    <div class="row pager-btn-row">
      <div v-if="canCreateClient && !isMensurationForbidden" class="col-md-12 text-right">
        <mdc-button class="button-primary" raised @click="onAddCuratorModalBtnClick">
          {{ 'user.add_client' | trans }}
        </mdc-button>
      </div>
    </div>

    <client-modal :visible="isModalVisible"
                  :data="modal.data"
                  v-on:close="onModalClose">
    </client-modal>
  </div>
</template>

<script>
  import axios from 'axios'
  import { mapGetters, mapActions } from 'vuex'
  import lang from '../../../../lang/translator'
  import Paginate from 'vuejs-paginate'
  import clientModal from './Modal'
  import clientBtn from './ClientBtn'
  import Loader from '../../../loader/components/Loader'
  import isEmpty from 'lodash/isEmpty'
  import Auth from '../../../../common/auth/Manager'
  import Search from '../../../../common/table/Search'
  import TableView from '../../../../common/table/components/TableView';

  export default {
    name: 'Clients',
    data () {
      return {
        apiUrl: '/users/therapists/' + Auth.getUserInfo().id + '/clients/hash/',
        therapistId: Auth.getUserInfo().id || null,
        isModalVisible: false,
        isOpen: false,
        responseHashError: null,
        paginate: {
          perPage: 10,
          page: 0,
          forcePage: 0,
          pageRange: 3,
          marginPages: 2,
        },
        user: {
          code: null,
        },
        modal: {
          data: {},
        },
        isChange: false,
        options: {
          pageHeader: 'clients',
          filterable: false,
          initialPage: null,
          sortable: [],
          withSearch: true,
          debounce: 1500,
          placeholder: lang.get('user.type_the_client_code_to_search'),
          skin: 'table table-sm',
          columns: [
            {
              key: 'client',
              changed: true,
              headings: lang.get('user.clients')
            },
            {
              key: 'hash',
              changed: false,
              headings: lang.get('user.number')
            },
            {
              key: 'action',
              changed: true,
              headings: ''
            }
          ],
          requestFunction: this.requestFunction,
          responseAdapter: function(resp) {
            return {
              data: resp.items,
              count: resp.total
            }
          },
          texts:{
            filter:"",
            filterPlaceholder: lang.get('user.type_the_client_code_to_search'),
            noResults:lang.get('bids.no_data'),
            loading: lang.get('home.labels.loading_message_table')
          },
          columnsClasses:{
            client :'wide-col',
            action:'table-actions'
          },
        },
        search: '',
        sort: '-id',
      }
    },

    components: {
      Search, Paginate, clientModal, clientBtn, Loader, TableView
    },
    computed: {
      ...mapGetters('client/repository', [
        'items',
        'page',
        'pageCount',
        'total',
        'hasMorePages',
        'isLoaded',
        'isChanged'
      ]),
      ...mapGetters('mobile', [
        'isMobile',
      ]),
      ...mapGetters('auth', [
        'canCreateClient',
        'canUpdateClient',
        'canDeleteClient',
        'isTherapist',
        'isMensurationForbidden',
      ]),
      isEmptyList: function () {
        return isEmpty(this.items)
      },
    },
    methods: {
      async requestFunction (data) {
        return this.getClients(data.page,this.sort,data.query)
      },
      ...mapActions('client/repository', [
        'getItems',
        'deleteItemById',
      ]),

      getTranslation (...args) {
        return lang.get(...args)
      },
      async getClients (page, sort, search, perPage) {
        localStorage.setItem('currentPage', page);
        localStorage.setItem('currentPageHeader', 'clients');
        let response = await this.getItems({
          perPage: this.paginate.perPage,
          page,
          sort: sort ? sort : this.sort,
          search: search ? search : this.search,
        });

        return response;
      },

      onModalClose () {
        this.modal.data = {}
        this.isModalVisible = false
        this.isChange = true;
      },
      onEditBtnClick (item) {
        this.isChange = false;
        this.modal.data = {item}
        this.isModalVisible = true
      },
      onAddCuratorModalBtnClick () {
        this.isChange = false;
        this.modal.data = {}
        this.isModalVisible = true
      },
      onDeleteBtnClick: async function (id) {
        this.isChange = false;
        await this.deleteItemById({id})
        let response = await this.getClients(this.page);

        if (response){
          this.isChange = true;
        }

        this.setPaginateState(this.page)
      },
      addHashBtnClick: async function () {
        this.disabled = true;
        this.isChange = false;
        let result = await this.$validator.validateAll()

        if (result === true) {
          let isSaved = axios.post(this.apiUrl, {'hash': this.user.code}).then(response => {
            this.responseHashError = null
            this.user.code = null
            //this.getClients()
            this.isChange = true;
          }).catch(error => {
            if (error.data) {
              this.disabled = false
              this.responseHashError = error.data.errors.hash.message
            }
          })
        }
      },
      async onPaginationClick (page) {
        await this.getClients(page)
        this.setPaginateState(page)
      },
      setPaginateState (page) {
        this.paginate.page = page
        this.paginate.forcePage = page - 1
      },
      onSearchEnter: function (search) {
        this.search = search
      },
    },
    watch: {
      pageCount (newValue, oldValue) {
        // spike :
        if (newValue > 1 && oldValue === 1) {
          this.paginate.page = 0
          this.paginate.forcePage = 0
        }
      },
      page (newValue, oldValue) {
        // spike :
        if (newValue === 1 && oldValue > 1) {
          this.paginate.page = 0
          this.paginate.forcePage = 0
        }
      },
      isChanged(newValue, oldValue) {
        if (newValue) {
          this.isChange = newValue
        }
      },
    },
  }
</script>



// WEBPACK FOOTER //
// src/modules/user/client/components/List.vue